module.exports = __webpack_public_path__ + "static/media/marnie.c3eb4989.png";